package de.connect2x.timmy.brandings.lifetimeTheme

import androidx.compose.runtime.Composable
import androidx.compose.runtime.Stable
import androidx.compose.ui.graphics.Color
import de.connect2x.timmy.brandings.aokTheme.messenger_theme_light_mention_border
import de.connect2x.trixnity.messenger.compose.view.theme.MessengerColors
import de.connect2x.trixnity.messenger.compose.view.theme.ThemeLightMessengerColors

object ThemeLightMessengerColorsWcImpl : ThemeLightMessengerColors {
    @Composable
    @Stable
    override fun create(accentColor: Color): MessengerColors {
        return MessengerColors(
            success = messenger_theme_light_success,
            presenceOnline = messenger_theme_light_success,
            presenceOffline = messenger_theme_light_neutral,
            presenceUnavailable = messenger_theme_light_error,
            verificationTrusted = messenger_theme_light_success,
            verificationUntrusted = messenger_theme_light_error,
            verificationNeutral = messenger_theme_light_neutral,
            metaDataPreview = messenger_theme_light_preview_content,
            metaDataPreviewBackground = messenger_theme_light_preview_scrim,
            blockedUser = messenger_theme_light_error,
            warning = messenger_theme_light_warning,
            link = messenger_theme_light_link_other,
            linkByMe = messenger_theme_light_link_own,
            userColors = messenger_theme_light_users,
            mentionBorder = messenger_theme_light_mention_border
        )
    }
}
